<template>
  <filter-multiselect
    label="Relation"
    placeholder="Owner, Rider or Family"
    :value="value"
    :options="options"
    @input="ids => $emit('input', ids)"
    @clear="$emit('clear')"
  />
</template>

<script>
import { HORSE_MEMBER_RELATION_OPTIONS } from '@/constants/horseMemberRelation'
import FilterMultiselect from './FilterMultiselect'

/**
 * The `relation` (Owner/Rider/Family) filter, shared by the Member Profile "Horses" tab
 * (CAM-1505) and the Horse Profile "Members" tab (CAM-1504) — same label, placeholder and
 * options in both places, just the `relation` filter value/handlers differ per page. Wraps
 * FilterMultiselect instead of duplicating its five bound props in every consumer.
 *
 *   <horse-member-relation-filter
 *     :value="filters.relation"
 *     @input="ids => setFilter('relation', ids)"
 *     @clear="clearFilter('relation')"
 *   />
 */
export default {
  name: 'HorseMemberRelationFilter',
  components: { FilterMultiselect },
  props: {
    value: { type: Array, default: () => [] }
  },
  data() {
    return { options: HORSE_MEMBER_RELATION_OPTIONS }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/HorseMemberRelationFilter.vue